<template>
    <div class="publicMain">
        <!-- 模糊查询 -->
        <div class="childrenFileSelect">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="员工类型">
                    <el-select v-model="form.workType">
                        <el-option label="管理人员" :value="1"></el-option>
                        <el-option label="护理人员" :value="2"></el-option>
                        <el-option label="医疗人员" :value="3"></el-option>
                        <el-option label="其他人员" :value="4"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onCheck">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="onReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 新增按钮 -->
        <div class="add">
            <el-button type="primary" @click="add" size="add">新增</el-button>
            <!-- <el-button type="primary" @click="addClassify" size="mini">新增分类</el-button> -->
        </div>
        <!-- 表格 -->
        <div class="table">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" width="50" label="序号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column
                        v-for="(item,index) in tableColumn"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        header-align="center"
                >
                    <template slot-scope="scope">
                        <div v-if="item.type=='button'" style="text-align: center">
                            <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
                            </el-tooltip>
                            <el-tooltip
                                    class="item"
                                    style="color:#dd3020;"
                                    effect="light"
                                    content="删除"
                                    placement="top-start"
                            >
                                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
                            </el-tooltip>
                        </div>
                        <div v-else-if="item.type=='workType'">
                            <div style="text-align:center;">
                                <el-tag v-if="scope.row.workType==1">管理人员</el-tag>
                                <el-tag v-if="scope.row.workType==2" type="success">护理人员</el-tag>
                                <el-tag v-if="scope.row.workType==3" type="primary">医疗人员</el-tag>
                                <el-tag v-if="scope.row.workType==4" type="warning">其他人员</el-tag>
                            </div>
                        </div>
                        <div v-else-if="item.type=='sex'">
                            <div style="text-align:center;">
                                <span v-if="scope.row.sex==0" type="success">男</span>
                                <span v-if="scope.row.sex==1" type="primary">女</span>
                            </div>
                        </div>
                        <div v-else-if="item.type=='nature'">
                            <div style="text-align:center;">
                                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>
                                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>
                                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>
                            </div>
                        </div>
                        <div
                                v-else
                                :style="{'text-align':item.align?item.align:'center'}"
                        >{{scope.row[item.prop]}}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
            ></el-pagination>
        </div>
        <!-- 弹窗 -->
        <el-dialog :title="title" :visible.sync="visible" width="40%">
            <div style="width:100%; width: 90%;margin: 0px auto;">
                <el-form
                        v-if="visible"
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="100px"
                        class="demo-ruleForm"
                >
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="员工类型">
                        <el-select v-model="ruleForm.workType">
                            <el-option label="管理人员" :value="1"></el-option>
                            <el-option label="护理人员" :value="2"></el-option>
                            <el-option label="医疗人员" :value="3"></el-option>
                            <el-option label="其他人员" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-model="ruleForm.phone">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="介绍" prop="introduce">
                        <el-input v-model="ruleForm.introduce">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="人员图片">
                        <upload :fileLists="fileList" :type="typeImg" @success="successImg" @deleteImg="deleteImg"/>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="address">
                        <el-input v-model="ruleForm.address" @blur="transLocation"></el-input>
                    </el-form-item>
                    <el-form-item label>
                        <div id="container" style="width:550px;height:400px;"></div>
                    </el-form-item>

                    <div class="button" v-if="title != '查看'">
                        <div class="button-mid">
                            <el-button type="primary" @click="save">确定</el-button>
                            <el-button type="info" @click="visible=false">取消</el-button>
                        </div>
                    </div>
                    <div class="button" v-else>
                        <div class="button-mid" style="text-align: center;justify-content: center">
                            <el-button type="info" @click="visible=false">取消</el-button>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        organizationPeopleDelete,
        organizationPeopleList,
        organizationPeopleCheck,
        organizationPeopleEdit, communityPeopleEdit, communityPeopleCheck,
    } from "../api";

    import request from "@/utils/request.js";
    import childrenPolicyPublicityDialog from "../components/childrenPolicyPublicityDialog.vue";
    import childrenPolicyPublicityDialogClassify from "../components/childrenPolicyPublicityDialogClassify.vue";
    import upload from "@/component/componentsP/upImg.vue";

    export default {
        components: {
            childrenPolicyPublicityDialog,
            childrenPolicyPublicityDialogClassify,
            upload
        },
        data() {
            return {
                currentPage: 1, //默认展示第一页
                title: "", //dialog的标题
                visible: false, //dialog的标题
                //模糊查询数据
                form: {},
                fileList: [],
                typeImg: "",
                visibleShow: false, //
                //table表格的column
                tableColumn: [
                    {
                        prop: "name",
                        label: "姓名"
                    },
                    {
                        type: "workType",
                        prop: "workType",
                        label: "员工类型"
                    },

                    {
                        prop: "phone",
                        label: "联系电话"
                    },

                    {
                        label: "操作",
                        type: "button"
                    }
                ],
                rules: {
                    name: [{required: true, message: "请输入姓名", trigger: "blur"}],
                    // startTime: [{ required: true, message: "请输入标题", trigger: "blur" }],
                    workType: [{required: true, message: "请选择员工类型", trigger: "blur"}],

                },
                //table表格的数据
                tableData: [],
                buttonType: false,
                row: {},
                total: 0, //总数据
                pageNo: 1,
                pageSize: 10,
                ruleForm: {},
                rulesDialog: {}
            };
        },
        methods: {
            //查询
            onCheck() {
                this.getAllChildrenPolicyListAPI({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    ...this.form
                });
                this.$message({
                    message: "查询成功",
                    type: "success"
                });
            },
            //重置
            onReset() {
                this.form = {};
                this.getAllChildrenPolicyListAPI({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize
                });
                this.$message({
                    message: "重置成功",
                    type: "success"
                });
            },
            //每页请求${val}条数据
            handleSizeChange(val) {
                this.pageSize = val;
                this.getAllChildrenPolicyListAPI();
                this.$message({
                    message: `每页请求${val}条数据成功`,
                    type: "success"
                });
            },
            //请求第${val}页数据
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getAllChildrenPolicyListAPI();
                this.$message({
                    message: `请求第${val}页数据成功`,
                    type: "success"
                });
            },
            //拿到列表
            getAllChildrenPolicyListAPI(e) {
                let params = Object.assign({}, e, {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    organId: this.$route.query.id
                });
                organizationPeopleList(params).then(res => {
                    this.tableData = res.content.list;
                    this.total = res.content.count;
                });
            },
            //新增按钮
            add() {
                this.visible = true;
                this.title = "新增";
                this.ruleForm = {};
                this.fileList = [];
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.mapInit('container')
                    }, 500)
                })
                try {
                    this.$refs.form.clearValidate()
                } catch (error) {

                }
            },
            //编辑
            compile(e) {
                this.visible = true;
                this.title = "编辑";
                this.getData({id: e.id})
            },
            //查看
            check(e) {
                this.visible = true;
                this.title = "查看";
                this.getData({id: e.id})
            },
            //删除
            remove(e) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                })
                    .then(() => {
                        organizationPeopleDelete({id: e.id}).then(res => {
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                            this.getAllChildrenPolicyListAPI();
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            //保存
            save() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        let photo = "";
                        if (this.fileList && this.fileList.length > 0) {
                            this.fileList.forEach((item) => {
                                photo += item.path + ";";
                            });
                        }
                        this.ruleForm = Object.assign({}, this.ruleForm, {
                            photo,
                            organId: this.$route.query.id
                        });
                        organizationPeopleEdit(this.ruleForm).then((res) => {
                            this.$message({
                                type: "success",
                                message: this.ruleForm.id ? "编辑成功" : "新增成功",
                            });
                            this.visible = false
                            this.getAllChildrenPolicyListAPI();
                        });
                    }
                });
            },
            successImg(e) {
                this.fileList = e;
            },

            deleteImg(e) {
                this.fileList = e;
            },
            //回写拿到数据
            getData(e) {
                organizationPeopleCheck(e).then((res) => {
                    this.ruleForm = res.content;
                    let arr = res.content.photo.split(";");
                    arr.pop();
                    this.fileList = arr.map((item) => {
                        return {
                            path: item,
                            name: item,
                        };
                    });
                    this.typeImg = "compile";
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.mapInit('container')
                        }, 500)
                    })

                });
            },
            //根据输入地址转换经纬度并标记
            transLocation() {
                var searchKey = this.ruleForm.address;
                var map = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 18,
                });
                var that = this;
                AMap.plugin("AMap.Geocoder", function () {
                    var geocoder = new AMap.Geocoder({
                        radius: 1000,
                        extensions: "all",
                    });
                    var marker = new AMap.Marker();
                    geocoder.getLocation(searchKey, function (status, result) {
                        if (status === "complete" && result.geocodes.length) {
                            var lnglat = result.geocodes[0].location;
                            that.ruleForm.longitude = String(lnglat.lng)
                            that.ruleForm.latitude = String(lnglat.lat);
                            marker.setPosition(lnglat);
                            map.add(marker);
                            map.setFitView(marker);
                        } else {
                            that.$message({
                                message: "获取坐标失败，请手动获取",
                                type: "error",
                            });
                        }
                    });
                });
                var geocoder = new AMap.Geocoder({
                    city: "010", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                });
                map.on("click", function (e) {
                    console.log("e", e);
                    that.ruleForm.longitude = String(e.lnglat.getLng());
                    that.ruleForm.latitude = String(e.lnglat.getLat());
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            if (status === "complete" && result.regeocode) {
                                console.log("result", result);
                                var address = result.regeocode.formattedAddress;
                                // that.form.address = address;
                                that.$set(that.ruleForm, "address", address);
                            } else {
                                log.error("根据经纬度查询地址失败");
                            }
                        }
                    );
                });
            },
            //初始化地图插件的方法
            mapInit(containerId) {
                var map = new AMap.Map(containerId, {
                    resizeEnable: true,
                    zoom: 18,
                });
                if (this.ruleForm.longitude != undefined && this.ruleForm.latitude != undefined) {
                    var marker = new AMap.Marker({
                        position: [Number(this.ruleForm.longitude), Number(this.ruleForm.latitude)],
                        map: map,
                    });
                    map.setFitView(marker);
                } else {
                    AMap.plugin("AMap.Geolocation", function () {
                        //异步定位当前
                        var geolocation = new AMap.Geolocation();
                        map.addControl(geolocation);
                    });
                }
                //定义地图坐标点击事件
                var that = this;
                var geocoder = new AMap.Geocoder({
                    city: "010", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                });
                map.on("click", function (e) {
                    that.ruleForm.longitude = e.lnglat.getLng();
                    that.ruleForm.latitude = e.lnglat.getLat();
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress;
                                // that.form.address = address;
                                that.$set(that.ruleForm, "address", address);
                            } else {
                                log.error("根据经纬度查询地址失败");
                            }
                        }
                    );
                });
            },
        },
        created() {
            this.getAllChildrenPolicyListAPI({
                pageNo: 1,
                pageSize: 10
            });
        }
    };
</script>

<style lang="less" scoped>
    .publicMain {
        background-color: #fff;
        padding: 16px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

    }

    // 面包屑导航box
    .mianbao {
        box-sizing: border-box;
        margin: -16px -16px 0;
        background-color: #eef1f6;
        height: 47px;
        align-items: center;
        padding-left: 16px;
        margin-bottom: 16px;
    }

    .childrenFileSelect {
        border: 1px solid rgb(230, 230, 230);
        padding: 20px;
    }

    .table {
        margin: 20px 0px;
    }

    .slot {
        width: 90%;
        height: 500px;
        overflow: auto;
        margin: auto;
    }

    .add {
        margin: 20px 0px;
    }

    .left {
        width: 45%;
        display: inline-block;
    }

    .right {
        width: 50%;
        display: inline-block;
        float: right;
    }

    .el-form-item__label {
        line-height: 20px !important;
    }

    .el-form-item {
        margin-bottom: 20px !important;
    }

    .el-radio {
        margin: 10px;
    }

    .button-mid {
        width: 300px;
        margin: 30px auto;
        display: flex;
        justify-content: space-between;
    }
</style>
